import { render, staticRenderFns } from "./CustomerCategory.vue?vue&type=template&id=4d83c908&scoped=true"
import script from "./CustomerCategory.vue?vue&type=script&lang=js"
export * from "./CustomerCategory.vue?vue&type=script&lang=js"
import style0 from "./CustomerCategory.vue?vue&type=style&index=0&id=4d83c908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d83c908",
  null
  
)

export default component.exports